module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('changePassword'),
      "visible": _vm._value,
      "id": "modal"
    },
    on: {
      "update:visible": function($event) {
        _vm._value = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "payload",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.payload
    }
  }, [_c('bootstrap-alert-errors', {
    attrs: {
      "errors": _vm.errors
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('currentPassword'),
      "prop": "currentPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "id": "currentPassword"
    },
    model: {
      value: (_vm.payload.currentPassword),
      callback: function($$v) {
        _vm.$set(_vm.payload, "currentPassword", $$v)
      },
      expression: "payload.currentPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('newPassword'),
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "id": "newPassword"
    },
    model: {
      value: (_vm.payload.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.payload, "newPassword", $$v)
      },
      expression: "payload.newPassword"
    }
  }), _vm._v(" "), _c('password', {
    attrs: {
      "strength-meter-only": true,
      "secureLength": 2
    },
    model: {
      value: (_vm.payload.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.payload, "newPassword", $$v)
      },
      expression: "payload.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('repeatNewPassword'),
      "prop": "repeatNewPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "id": "repeatNewPassword"
    },
    model: {
      value: (_vm.payload.repeatNewPassword),
      callback: function($$v) {
        _vm.$set(_vm.payload, "repeatNewPassword", $$v)
      },
      expression: "payload.repeatNewPassword"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "id": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("close")) + "\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "id": "save"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("save")) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-474bf0a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/user/components/ChangePasswordDialogForm.vue
// module id = 920
// module chunks = 2